module.exports = "/_next/static/images/LCTM-201b5069458771ee038e9c34383d2ae1.svg";